export function reverseErrorMessageToChinese (text) {
  const message = {
    E_DATASET_NOT_FOUND: '找不到資料集',
    E_DATASET_UNCHANGED: '資料集未有更動',
    E_MODEL_IS_TRAINIG: '模型正在訓練中',
    E_IMAGE_NOT_FOUND: '找不到圖片',
    E_MODEL_EXISTS: '模型已存在',
    E_INVALID_TOKEN: 'Access Token 驗證失敗',
    E_NO_CLASSES: '沒有類別',
    E_NO_FILE: '沒有檔案',
    E_UNACCEPTABLE_ZIP: '這不是一個可接受的 ZIP 壓縮檔',
    E_UNACCEPTABLE_FILE: '這不是一個可接受的影像檔',
    E_INVALID_VALUE: '不正確的輸入值',
    E_INVALID_CLASSES: '不正確的類別值',
    E_NO_USER_ID: '沒有使用者 ID',
    E_NO_MODEL_ID: '沒有模型 ID',
    E_NO_INPUT_FILE: '沒有輸入檔案',
    E_NO_TRAIN_DATA: '沒有訓練資料',
    E_WORKER_DOWN: 'Worker 異常下線',
    E_NO_WORKER: '沒有 Worker',
    E_NO_WORKER_ID: '沒有 Worker ID',
    E_NOT_FOUND: '找不到',
    E_TRAIN_FAIL: '訓練失敗',
    E_MODEL_IS_DETECTING: '先前模型正在計算，勿重複請求，請稍等半分鐘後重新請求'
  }
  return message[text]
}
